import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MainContext } from "../../Main";

import "./Zone5.scss";
import "./Adaptations.scss";
// import { zone2_land_plots } from "./land_plots";
// import { zone2_blocks } from "./blocks";

import Reel from "../../../../components/main/reel/Reel";
import MasterPlan from "../master-plan/MasterPlan";
import BackButton from "../../../../components/main/menu/back-button/BackButton";
import Switch2 from "../../../../components/switch/Switch2";

import startFrame from "../../../../static/images/contents/zone-2/temp.jpg";

import { TopLogoAlZumuruda } from "../../../../components/main/menu/top-logo/TopLogo";
// import ServicesButton from "../../../../components/main/menu/services/ServicesButton";
import PopUp from "../../../../components/pop-up/PopUp";

// Generated polygon mapping files
import { zone2_plot_polygons } from "./generated/plots_map";
import { zone2_block_polygons } from "./generated/blocks_map";
import SvgAreas from "../../../../components/main/wrappers/svg-areas/SvgAreas";
import unitSizeJSON from "./unit_sizes.json";
import { fetchBlocksByZone, fetchPlotsByZone } from "../../../../utils/api";
import { zone2_landmarks as landmarks } from "./landmarks";

export default function Zone5() {
    const [t] = useTranslation();

    const [changeContent] = useContext(MainContext);
    const [switchState, setSwitchState] = useState(true);
    const [isLoaded, setIsLoaded] = useState(false);
    const onLoad = () => {
        setIsLoaded(true);
    };

    const [plotData, setPlotData] = useState([]);
    const [blockData, setBlockData] = useState([]);

    useEffect(() => {
        fetchPlotsByZone(2)
            .then(setPlotData)
            .catch(() => setPlotData([]));
        fetchBlocksByZone(2)
            .then(setBlockData)
            .catch(() => setBlockData([]));
    }, []);

    const stopsPlots = zone2_plot_polygons.map((group) => ({
        index: group.wrapperIndex,
        default: true,
        wrapper: (
            <>
                <SvgAreas
                    unitSizeJSON={unitSizeJSON}
                    areas={group.areas.map((a) => {
                        const plot = plotData.find(
                            (p) => p.plot_number === a.plotIndex
                        );
                        return {
                            Polygon: a.Polygon,
                            className: null,
                            infobox: plot
                                ? {
                                      type: "land_info",
                                      index: plot.plot_number,
                                      status: plot.status,
                                      block: plot.block_number,
                                      unitSize: plot.unit_size,
                                      north: plot.north,
                                      east: plot.east,
                                      south: plot.south,
                                      west: plot.west,
                                      front1: plot.front1,
                                      front2: plot.front2,
                                      electricTransformer:
                                          plot.electric_transformer,
                                      st_width_1: plot.st_width_1,
                                      st_width_2: plot.st_width_2,
                                  }
                                : null,
                        };
                    })}
                />
                {landmarks.find((l) => l.index === group.wrapperIndex)?.wrapper}
            </>
        ),
    }));

    const stopsBlocks = zone2_block_polygons.map((group) => ({
        index: group.wrapperIndex,
        default: true,
        wrapper: (
            <>
                <SvgAreas
                    unitSizeJSON={unitSizeJSON}
                    areas={group.areas.map((a) => {
                        const block = blockData.find(
                            (b) => b.block_number === a.blockIndex
                        );
                        return {
                            Polygon: a.Polygon,
                            className: null,
                            infobox: block
                                ? {
                                      type: "block_info",
                                      index: block.block_number,
                                      status: block.status,
                                  }
                                : null,
                        };
                    })}
                />
                {landmarks.find((l) => l.index === group.wrapperIndex)?.wrapper}
            </>
        ),
    }));

    return (
        <div className="zone-5" style={{ width: "100%", height: "100%" }}>
            <TopLogoAlZumuruda />
            {/* <ServicesButton setModalContent={setModalContent} /> */}
            {isLoaded && (
                <>
                    <div className="zone-5-switches">
                        <Switch2
                            switchChecked={switchState}
                            handleSwitchCheck={setSwitchState}
                            labelText={t("zone_5_switch_land_plot")}
                            labelText2={t("zone_5_switch_blocks")}
                        />
                        {/* <Switch
                            switchChecked={switchState}
                            handleSwitchCheck={setSwitchState}
                            labelText={t("zone_5_switch_land_plot")}
                        />
                        <Switch
                            switchChecked={!switchState}
                            handleSwitchCheck={setSwitchState}
                            labelText={t("zone_5_switch_blocks")}
                        /> */}
                    </div>
                    <PopUp title={t("tip_title")} desc={t("tip_desc")} />
                </>
            )}
            <Reel
                folder="static/contents/zone-2/renders"
                amount={120}
                qualitySteps={1}
                defaultControlsPart={0.075}
                stops={switchState ? stopsPlots : stopsBlocks}
                overlay_elements={null} // Soon
                wrapper_animation_key={switchState}
                startFrame={startFrame}
                onReelReady={onLoad}
            />

            <BackButton
                onClick={() =>
                    changeContent(<MasterPlan />, {
                        button: "menu_master_plan",
                        element: null,
                        head_title: null,
                    })
                }
            />
        </div>
    );
}
